<template>
  <div v-if="provider" class="provider-detail">
    <div class="grid-x grid-padding-x">
      <div class="cell small-12 medium-4 large-3">
        <div class="small-text-center">
          <img 
            v-if="provider.image_url" 
            :src="provider.image_url" 
            :id="'img-' + provider.id"
            class="square rounded"
            style="margin-bottom:1rem;max-width:300px">
        </div>
        <back-link v-if="!isSmall"></back-link>
      </div>
      <div class="cell small-12 medium-8">
        <div class="grid-x grid-padding-x">
          <div class="cell medium-auto small-text-center medium-order-2">
            <site-logos :sites="provider.sites"></site-logos>
          </div>
          <div class="cell medium-shrink medium-order-1">
            <h3 class="no-wrap no-margin bold small-text-center">
              {{ provider.formatted_name }}
            </h3>
          </div>
        </div>
        
        <h4 class="small-text-center">{{ provider.specialties | implode }}</h4>
        <h6 class="bold small-text-center">Populations served: {{ provider.populations | implode }}</h6>
        
        <vue-tabs>
          <v-tab title="About">
            <div 
              v-if="provider.extra_info" 
              v-html="provider.extra_info" 
              class="extra-info">
            </div>
            <div 
              v-if="provider.certifications">
              <h5>Certifications:</h5>
              <ul class="square-bullets">
                <li 
                  v-for="(item, index) in provider.certifications" 
                  :key="index">
                  {{ item.title }}
                </li>
              </ul>
              <hr>
            </div>

            <div 
              v-if="provider.references">
              <h5>Education/Training:</h5>
              <ul class="square-bullets">
                <li 
                  v-for="(item, index) in provider.references"
                  :key="index">
                  <reference :item="item"></reference>
                </li>
              </ul>
            </div>

            <div 
              v-if="pages">
              <h5>See also:</h5>
              <ul class="square-bullets">
                <li v-for="(page, index) in pages" :key="index">
                  <a :href="page.url">{{ page.title }}</a>
                </li>
              </ul>
            </div>
          </v-tab>

          <v-tab v-if="provider.locations" title="Locations">
            <div class="grid-x grid-padding-x small-up-1 medium-up-2 large-up-2">
                <div 
                  v-for="(location, index) in provider.locations"
                  :key="index"
                  class="cell">
                  <div style="margin:1.5rem 0 2rem 0">
                    <location-card 
                      :location="location"
                      :map="map"
                      @show-map="showOnMap">
                    </location-card>
                  </div>
                </div>
            </div>
          </v-tab>
        </vue-tabs>
      </div>
    </div>
    <back-link v-if="isSmall"></back-link>
  </div>
</template>

<script>
import {_} from 'vue-underscore'
import BackLink from '@/BackLink.vue'
import LeafletMap from '@/LeafletMap.vue'
import LocationCard from '@/LocationCard.vue'
import Reference from '@/Reference.vue'
import SiteLogos from '@/SiteLogos.vue'
import {VueTabs, VTab} from 'vue-nav-tabs'

export default {
  name: 'Provider',
  components: {
    BackLink,
    LocationCard,
    Reference,
    SiteLogos,
    VueTabs, 
    VTab
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      result: false,
      defaultModalWidth: 900,
      defaultModalHeight: 500
    }
  },
  methods: {
    getProvider (id) {
      const options = {
        method: 'post',
        data: {
          action: 'provider',
          provider_id: id
        }
      }
      this.$dispatch.sendRequest(options)
      .then(function (response) {
        if (response.data.success) {
          this.result = response.data.provider
        } else {
          this.$commit.status('error', 'Could not retrieve provider data')
        }
      }.bind(this))
    },
    showOnMap (location) {
      let options = {
        name: 'modal-location-map-' + location.id,
        width: this.modalSize.width,
        height: this.modalSize.height
      }

      let elem = document.querySelector('body')
      if (elem) {
        elem.classList.add('no-scroll')
      }

      this.$modal.show(
        LeafletMap, 
        { 
          title: location.title,
          latlng: [location.lat, location.lng]
        }, 
        options
      )
    }
  },
  filters: {
    implode (val) {
      // Get item titles as a string
      let titles = _.pluck(val, 'title')
      if (titles) {
        return titles.join(', ')
      }
      return ''
    }
  },
  computed: {
    isSmall () {
      return this.$util.isSmall()
    },
    pages () {
      if (this.provider.linked_pages) {
        return this.provider.linked_pages
      }
      return false
    },
    provider () {
      return this.result
    },
    modalSize () {
      const vp = this.$util.getViewport()
      if (window.matchMedia('(max-width: 640px)').matches) {
        return {
          width: vp.width - 10,
          height: vp.height - 10
        }
      } else {
        return {
          width: this.defaultModalWidth,
          height: this.defaultModalHeight
        }
      }
    }
  },
  mounted () {
    const provider_id = Number(this.id)
    if (provider_id) {
      // Attempt to find in current result
      this.result = _.find(this.$store.result.items, function (item) {
        return item.id == provider_id
      })
      if (!this.result) {
        this.getProvider(provider_id)
      }
    }
  }
}

</script>